/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import PavillonSearchCustomerSalesRightsMutation from '../graphql/mutations/PavillonSearchCustomerSalesRightsMutation.js';

export const usePavillonSearchCustomerSalesRightsMutation = () => {
  return useCommitMutation(PavillonSearchCustomerSalesRightsMutation, {
    dataProp: 'pavillonSearchCustomerSalesRights_M_simulation_customer_grantees'
  });
};

export default usePavillonSearchCustomerSalesRightsMutation;
